import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./LoginPage";
import AdminDashboard from "./AdminDashboard";
import DriverDashboard from "./DriverDashboard";
import TransporterDashboard from "./TransporterDashboard";
import SignupPage from "./SignupPage";

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing Page */}
        <Route path="/" element={<LoginPage />} />

        {/* Admin Page */}
        <Route path="/AdminDashboard" element={<AdminDashboard />} />

        {/* Driver Dashboard */}
        <Route path="/DriverDashboard" element={<DriverDashboard />} />

        {/* Transporter Dashboard */}
        <Route path="/TransporterDashboard" element={<TransporterDashboard />} />

        {/* SignUp Page */}
        <Route path="/signup" element={<SignupPage />} />

      </Routes>
    </Router>
  );
}

export default App;
